const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermostat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "\u0428\u0430\u0440_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248 249",
    style: {
      enableBackground: "new 0 0 248 249"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFDFE;}\r\n\t.st1{fill:#FFFDFE;stroke:#DDDBDE;stroke-width:1.0168;stroke-miterlimit:10;}\r\n\t.st2{fill:#020203;}\r\n\t.st3{fill:url(#SVGID_1_);}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n\t.st5{opacity:0.57;fill:url(#SVGID_3_);}\r\n\t.st6{opacity:0.57;fill:url(#SVGID_4_);}\r\n\t.st7{opacity:0.57;fill:url(#SVGID_5_);}\r\n\t.st8{fill:#969392;}\r\n\t.st9{opacity:0.49;fill:url(#SVGID_6_);}\r\n"), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.2,235.1H7c-1.3,0-2.4-1.1-2.4-2.4V6.6c0-1.3,1.1-2.4,2.4-2.4h226.1c1.3,0,2.4,1.1,2.4,2.4v226.1 C235.6,234,234.5,235.1,233.2,235.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 248,
    height: 249,
    xlinkHref: "E76E3011.png"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.3,208.2H43c-6.1,0-11-4.9-11-11V42.9c0-6.1,4.9-11,11-11h153.3c6.1,0,11,4.9,11,11v154.2 C207.3,203.3,202.4,208.2,196.3,208.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176,182.1H64c-3.8,0-6.8-3.1-6.8-6.8V63.9c0-3.8,3.1-6.8,6.8-6.8h112c3.8,0,6.8,3.1,6.8,6.8v111.4 C182.8,179,179.8,182.1,176,182.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.3898,
    y1: 173.1679,
    x2: 179.0056,
    y2: 173.1679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A1A1A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.1,164.2c36.6,0,73.2,0,109.9,0c1.4,5.7,2.7,11.4,4.1,17.1c-0.3,0.2-0.7,0.3-1.2,0.5 c-1.2,0.3-2.1,0.3-2.3,0.3c-2.1-0.1-110.7,0-111.4,0c-0.5,0-1,0-1.7-0.2c-0.4-0.1-0.7-0.2-1-0.3C62.6,175.8,63.9,170,65.1,164.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.15,
    y1: 182.0953,
    x2: 120.15,
    y2: 164.2474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M65.1,164.2c36.6,0,73.2,0,109.9,0c1.3,5.7,2.6,11.4,4,17.1c-0.3,0.2-0.8,0.3-1.3,0.5c-1.1,0.3-2,0.2-2.1,0.2 c-2.4-0.1-110.7,0-111.4,0c-0.5,0-1,0-1.7-0.2c-0.4-0.1-0.7-0.2-1-0.3C62.6,175.8,63.9,170,65.1,164.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.9771,
    y1: 74.8506,
    x2: 119.9771,
    y2: 57.0199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.1,74.9c36.6,0,73.2,0,109.7,0c2.4-4.7,4.8-9.3,7.2-14c-1-1.3-2.4-2.8-4.4-3.4c-1-0.3-1.8-0.4-2.1-0.4 c-37.1,0-74.3,0-111.4,0c-0.1,0-0.3,0-0.5,0c0,0-0.6,0-1.2,0.2c-1.4,0.4-2.6,1.3-2.6,1.3c-1.1,0.8-1.6,1.8-1.9,2.3 C60.3,65.5,62.7,70.2,65.1,74.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.1356,
    y1: 121.2018,
    x2: 65.1003,
    y2: 121.2018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M65.1,164.2V74.9l-7.2-14c-0.2,0.3-0.4,0.7-0.5,1.2c-0.2,0.6-0.2,1.2-0.2,1.6c0,37.2,0,74.3,0,111.5 c0,0.6,0.1,2.6,1.6,4.4c1,1.2,2.1,1.7,2.7,2C62.6,175.8,63.9,170,65.1,164.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.8641,
    y1: 121.388,
    x2: 182.8288,
    y2: 121.388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174.9,164.2l0-89.4l7.2-14c0.2,0.3,0.4,0.7,0.5,1.2c0.2,0.6,0.2,1.2,0.2,1.6c0,37.2,0,74.3,0,111.5 c0,0.8-0.2,2.8-1.6,4.4c-1.2,1.4-2.7,2-3.8,2.4C176.6,176,175.7,170.1,174.9,164.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.8,189.9l-4.5,4.6c-0.2,0.2-0.5,0.4-0.7,0.4c-0.1,0-0.1,0-0.2,0c-0.2,0-0.2-0.1-0.2-0.1 c-0.1-0.1-0.1-0.1,0.2-0.4l2-2.1c0.4-0.4,0.5-0.7,0.3-1c-0.1-0.2-0.3-0.4-1.1-0.5c-0.7-0.1-1.1-0.2-1.7,0c-0.6,0.1-1.1,0.5-1.4,0.9 l-2.5,2.6v1.8l4-4.2c0.3-0.3,0.5-0.3,0.6-0.4c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0.2,0,0.2,0.1,0.2,0.1c0,0,0.1,0.1-0.2,0.4l-2,2.1 c-0.4,0.4-0.5,0.8-0.3,1c0.1,0.2,0.4,0.4,1.1,0.5c0.2,0,0.7,0.1,0.9,0.1c0.8,0,1.5-0.2,2.2-0.9l0.9-1l3.9-4H193.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "165.5,190.8 170.9,190.8 170.9,192.3 167.6,192.3 167.6,193.9 170.9,193.9 170.9,195.3 167.6,195.3  167.6,197.1 170.9,197.1 170.9,198.5 165.5,198.5 165.5,190.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.1,
    y: 190.8,
    className: "st8",
    width: 2.1,
    height: 7.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "178.2,190.8 176.7,190.8 175,196.1 175,196.1 173.4,190.8 171.8,190.8 171.8,192.6 173.7,198.5  176.2,198.5 178.2,192.6 178.2,190.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M164.6,193.1c-0.5-1.5-1.8-2.3-3.9-2.3H158v7.7h2.7c2.1,0,3.4-0.8,3.9-2.3V193.1 M160.7,197.1h-0.5v-4.8h0.5 c1.4,0,2,0.6,2,2.4S162,197.1,160.7,197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M183.2,191.4c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6C183,190.8,183.2,191,183.2,191.4  M183.1,191.4c0-0.3-0.2-0.5-0.4-0.5c-0.2,0-0.4,0.2-0.4,0.5c0,0.3,0.2,0.5,0.4,0.5C182.9,191.9,183.1,191.6,183.1,191.4z  M182.7,191.7c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.1-0.1-0.1-0.1v0.3h-0.2v-0.6h0.3c0.1,0,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.2 c0,0,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2H182.7z M182.6,191.2L182.6,191.2l0,0.1h0C182.6,191.3,182.7,191.3,182.6,191.2 C182.7,191.2,182.6,191.2,182.6,191.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M183.9,198.5c0-0.1,0-0.2,0-0.3v-1.3h0.3v0.6h0c0.1-0.1,0.2-0.2,0.3-0.2c0.3,0,0.5,0.2,0.5,0.6 c0,0.4-0.3,0.6-0.5,0.6c-0.1,0-0.3,0-0.3-0.2h0l0,0.2H183.9 M184.3,198.1C184.3,198.1,184.3,198.1,184.3,198.1 c0,0.2,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.3c0-0.2-0.1-0.3-0.2-0.3c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0.1V198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.5,197.4l0.2,0.5c0,0.1,0,0.1,0.1,0.2h0c0-0.1,0-0.1,0-0.2l0.1-0.5h0.4l-0.3,0.7c-0.2,0.4-0.3,0.6-0.4,0.7 c-0.1,0.1-0.2,0.1-0.3,0.2l-0.1-0.3c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0-0.1l-0.4-1H185.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187,197c0.1,0,0.3,0,0.5,0c0.3,0,0.5,0.1,0.6,0.2c0.2,0.1,0.3,0.3,0.3,0.6c0,0.3-0.1,0.5-0.3,0.6 c-0.2,0.1-0.4,0.2-0.7,0.2c-0.2,0-0.3,0-0.4,0V197 M187.3,198.3c0,0,0.1,0,0.1,0c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5 c-0.1,0-0.1,0-0.2,0V198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.2,198.5l0-0.1h0c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.4-0.2-0.4-0.3c0-0.3,0.3-0.4,0.6-0.4v0 c0-0.1,0-0.1-0.2-0.1c-0.1,0-0.2,0-0.3,0.1l-0.1-0.2c0.1,0,0.2-0.1,0.4-0.1c0.4,0,0.5,0.2,0.5,0.5v0.4c0,0.1,0,0.2,0,0.3H189.2  M189.1,198c-0.2,0-0.3,0-0.3,0.2c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.2-0.1c0,0,0,0,0-0.1V198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M189.7,197.8c0-0.1,0-0.3,0-0.4h0.3l0,0.2h0c0-0.1,0.2-0.2,0.3-0.2c0.2,0,0.4,0.1,0.4,0.5v0.7h-0.3v-0.6 c0-0.1,0-0.2-0.2-0.2c-0.1,0-0.2,0.1-0.2,0.1c0,0,0,0.1,0,0.1v0.6h-0.3V197.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M191.1,198.5v-0.8H191v-0.3h0.1v0c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0l0,0.3 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.2,0.2v0.1h0.2v0.3h-0.2v0.8H191.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M192.9,198c0,0.4-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.2-0.6-0.6c0-0.4,0.2-0.6,0.6-0.6 C192.7,197.4,192.9,197.6,192.9,198 M192.1,198c0,0.2,0.1,0.3,0.2,0.3c0.1,0,0.2-0.1,0.2-0.3c0-0.2-0.1-0.3-0.2-0.3 C192.2,197.6,192.1,197.8,192.1,198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.2,198.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.1-0.1s0-0.1-0.2-0.1c-0.2-0.1-0.3-0.2-0.3-0.3 c0-0.2,0.2-0.4,0.4-0.4c0.1,0,0.2,0,0.3,0.1l-0.1,0.2c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.2,0.1 c0.2,0.1,0.3,0.2,0.3,0.3c0,0.2-0.2,0.4-0.5,0.4c-0.1,0-0.3,0-0.4-0.1L193.2,198.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M194.2,198.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.1-0.1s0-0.1-0.2-0.1c-0.2-0.1-0.3-0.2-0.3-0.3 c0-0.2,0.2-0.4,0.4-0.4c0.1,0,0.2,0,0.3,0.1l-0.1,0.2c0,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.2,0.1 c0.2,0.1,0.3,0.2,0.3,0.3c0,0.2-0.2,0.4-0.5,0.4c-0.1,0-0.3,0-0.4-0.1L194.2,198.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.3898,
    y1: 173.0647,
    x2: 65.6511,
    y2: 173.0647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6237,
    style: {
      stopColor: "#ABAAAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "61.4,181.5 65.1,164.2 65.7,164.2 62.4,181.9 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermostat);
export default __webpack_public_path__ + "static/media/termostat.e1ea479cd6cda3e8b0a3634c1480f031.svg";
export { ForwardRef as ReactComponent };